module.exports = __webpack_public_path__ + "img/IMG_7521.bcad7b0e.png";